import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { PromotoresService } from '../../../../services/promotores.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
import { DatesHelpersService } from '../../../../services/tools/dates-helpers.service';

@Component({
    selector: 'app-modal-promotor',
    templateUrl: './modal-promotor.component.html'
  })

export class ModalPromotorComponent implements OnInit {
    @ViewChild('btnShowModal') btnShowModal: ElementRef;
    @ViewChild('btnClose') btnClose: ElementRef;

    @Output() public savedPromotor : EventEmitter<void> = new EventEmitter;

    public promotor:any = {};
    public errors:any = {};

    constructor(
        private service : PromotoresService,
        private helperService: HelpersService,
        private datesHelpersService: DatesHelpersService
    ){
    }

    public ngOnInit() {
    }

    public showModal(){
        this.promotor = {};
        this.btnShowModal.nativeElement.click();
    }

    public editPromotor(idPromotor: number){
        this.showModal();

        this.service.get(idPromotor).subscribe(
        (response)=>
        {
            const jsonResult = response.json();
            let promotor = jsonResult.content;   
            //El componente de ngCalendar requiere que asignemos la fecha con formato de json
            promotor.fecha_nacimiento_json =  this.datesHelpersService.dateToObj(promotor.fecha_nacimiento);
            this.promotor = promotor;
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
        );
    }

    public save(){
        this.errors = {};
        let promotor = this.promotor;
        promotor.fecha_nacimiento = promotor.fecha_nacimiento_json ? this.datesHelpersService.dateToString(promotor.fecha_nacimiento_json) : '';
    
        this.errors = this.service.validate(promotor);

        if (Object.entries(this.errors).length > 0) {
            return false;
        }
    
        if(promotor.id){
          //Update pago
          this.update(promotor);
        }else{
          //New pago
          this.create(promotor);
        }
    }
    
    private create(promotor : any){
        this.service.save(promotor).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.helperService.notification('Promotor creado', 'Se ha registrado exitosamente el promotor', 'success');
            this.btnClose.nativeElement.click();
            this.savedPromotor.emit();
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content,this.errors);
            }
          }
        );
    }

    private update(promotor : any){
        this.service.update(promotor).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.helperService.notification('Promotor creado', 'Se ha registrado exitosamente el promotor', 'success');
            this.btnClose.nativeElement.click();
            this.savedPromotor.emit();
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content,this.errors);
            }
          }
        );
    }

    
}


// WEBPACK FOOTER //
// ./src/app/promotores/listado/components/modal-promotor/modal-promotor.component.ts